export enum Navigation {
    NEXT = "NEXT",
    PREV = "PREV",
    NONE = "NONE"
}
